import React from 'react';
import { Link } from 'react-router-dom';

import { useMediaQuery } from '../../hooks/useMediaQuery';
import { FILLS, FONTS, RADII } from '../../styles/tokens';
import { MD_BREAKPOINT } from '../../utils/breakpoints';

interface TermsOfServiceProps {
  accepted: boolean;
  onAcceptanceChange: (accepted: boolean) => void;
  disabled?: boolean;
  error?: string;
}

const TermsOfService: React.FC<TermsOfServiceProps> = ({
  accepted,
  onAcceptanceChange,
  disabled = false,
  error,
}) => {
  const isMobile = useMediaQuery(`(max-width: ${MD_BREAKPOINT - 1}px)`);

  const inlineLinkStyle: React.CSSProperties = {
    color: FILLS.textPrimary,
    textDecoration: 'underline',
    textUnderlineOffset: '2px',
    fontFamily: 'inherit',
    fontSize: 'inherit',
    lineHeight: 'inherit',
  };

  return (
    <>
      {/* Compact tos-check row — checkbox carries its own accessible name so
          the adjacent sentence's links never sit inside the checkbox's
          label activation area (click-misfire + a11y risk). */}
      <div
        style={{
          display: 'flex',
          alignItems: 'flex-start',
          gap: '10px',
          marginBottom: error ? '12px' : 0,
        }}
      >
        <input
          type="checkbox"
          checked={accepted}
          onChange={(e) => onAcceptanceChange(e.target.checked)}
          disabled={disabled}
          aria-label="I agree to Belhop's Terms of Service, Privacy Policy and Cancellation Policy"
          aria-describedby={error ? 'terms-error-message' : undefined}
          style={{
            width: '18px',
            height: '18px',
            accentColor: FILLS.gold,
            cursor: disabled ? 'not-allowed' : 'pointer',
            marginTop: '1px',
            flexShrink: 0,
          }}
        />
        <span
          style={{
            fontSize: '13px',
            color: FILLS.textLight,
            fontFamily: FONTS.body,
            lineHeight: 1.5,
          }}
        >
          I agree to Belhop&apos;s{' '}
          <Link to="/terms" target="_blank" rel="noopener noreferrer" style={inlineLinkStyle}>
            Terms of Service
          </Link>
          ,{' '}
          <Link to="/privacy" target="_blank" rel="noopener noreferrer" style={inlineLinkStyle}>
            Privacy Policy
          </Link>{' '}
          and{' '}
          <Link
            to="/terms#cancellations-and-refunds"
            target="_blank"
            rel="noopener noreferrer"
            style={inlineLinkStyle}
          >
            Cancellation Policy
          </Link>
          .
        </span>
      </div>

      {error && (
        <div
          className="alert alert-error"
          id="terms-error-message"
          role="alert"
          style={{ borderRadius: isMobile ? '0' : RADII.card }}
        >
          {error}
        </div>
      )}
    </>
  );
};

export default TermsOfService;
